/**
 * Get the discount value of a given product
 * @param  {Int}    platformID        ID of the targeted platform
 * @param  {Int}    gameID            ID of the targeted game
 * @param  {Object} discountPromos    List of discount promotions
 * @return {Object}                   The current promotion for the specific product
 */

import { dateFormat } from '../date-time'


export function getDiscount(platformID, gameID, discountPromos, freePromos, strings) {
  if (!gameID || gameID === null) {
    return ''
  }

  let currentDiscount = []

  // Free Week-end Promos
  if (gameID.includes('free-weekend') && freePromos) {
    freePromos.forEach((promo) => {
      let currentPlatform = promo?.platform.toLowerCase()
      let now = new Date()
      let currentDate = dateFormat(now, promo?.timezone)
      let startDate = dateFormat(promo?.startDate, promo?.timezone)
      let endDate = dateFormat(promo?.endDate, promo?.timezone)
      let currentTimeFrame = currentDate >= startDate && currentDate < endDate

      const freeTag = strings?.free || 'Free'

      if (currentPlatform === platformID) {
        let formatedPromo = {
          platform: promo?.platform,
          promo: freeTag,
          label: freeTag,
          startDate: promo?.startDate,
          endDate: promo?.endDate,
          timezone: promo?.timezone,
          active: currentTimeFrame,
        }
        if (currentTimeFrame) {
          currentDiscount.push(formatedPromo)
        }
      }
    })
  }

  // Discount Promos
  discountPromos.forEach((sale) => {
    sale?.promos.forEach((promo) => {
      // Format the promo platform names to match Purchase flow data
      if (
        promo?.platform !== null &&
        promo?.promo !== null &&
        promo?.startDate !== null &&
        promo?.endDate !== null
      ) {

        let currentPlatform = promo?.platform.toLowerCase()
        let now = new Date()
        let currentDate = dateFormat(now, promo?.timezone)
        let startDate = dateFormat(promo?.startDate, promo?.timezone)
        let endDate = dateFormat(promo?.endDate, promo?.timezone)
        let currentTimeFrame = currentDate >= startDate && currentDate < endDate

        if (currentPlatform === 'windows') {
          currentPlatform = 'microsoft'
        }
        if (gameID.includes('base-game') || gameID.includes('main-game')) {
          // Apply promo to the main game
          if (sale.applyBaseGame) {
            if (currentPlatform === platformID) {
              let formatedPromo = {
                platform: promo?.platform,
                promo: promo?.promo,
                label: promo?.label,
                startDate: promo?.startDate,
                endDate: promo?.endDate,
                timezone: promo?.timezone,
                active: currentTimeFrame,
              }
              if (currentTimeFrame) {
                currentDiscount.push(formatedPromo)
              }
            }
          }
        } else {
          // Apply promo to all chapters
          if (sale.applyDefaultChapters) {
            if (currentPlatform === platformID) {
              let promoValue = promo?.promo
              let activePromo =
                currentDate >= startDate &&
                  currentDate < endDate &&
                  promoValue !== '0%' &&
                  promoValue !== '0'
                  ? true
                  : false

              // Lookup if current chapter has a custom promotion
              sale.customPromo?.forEach((customPromo) => {
                let chapterNumber = customPromo?.chapter?.chapterNumber
                let chapterSlug = customPromo?.chapter?.slug?.replace(/-/g, ' ')
                gameID = gameID.replace(/-/g, ' ')
                let formatedChapterName = `ch${chapterNumber} ${chapterSlug}`

                // DLC Pack ID
                if (customPromo.gameId) {
                  formatedChapterName = customPromo.gameId?.replace(/-/g, ' ')
                }

                if (gameID === formatedChapterName) {
                  promoValue = customPromo?.promo
                  activePromo =
                    currentTimeFrame &&
                      promoValue !== '0%' &&
                      promoValue !== '0'
                      ? true
                      : false
                }
              })
              let formatedPromo = {
                platform: promo?.platform,
                promo: promoValue,
                label: promo?.label,
                startDate: promo?.startDate,
                endDate: promo?.endDate,
                timezone: promo?.timezone,
                active: activePromo,
              }
              if (currentTimeFrame) {
                currentDiscount.push(formatedPromo)
              }
            }
          } else {
            if (
              sale.targetChapters &&
              sale.targetChapters.chapterNumber !== null
            ) {
              sale.targetChapters.forEach((target) => {
                if (currentPlatform === platformID) {
                  let chapterNumber = target?.chapterNumber
                  let chapterSlug = target?.slug?.replace(/-/g, ' ')
                  let formatedChapterName = `ch${chapterNumber} ${chapterSlug}`
                  gameID = gameID.replace(/-/g, ' ')

                  if (gameID === formatedChapterName) {
                    let promoValue = promo?.promo

                    // Lookup if current chapter has a custom promotion
                    sale.customPromo?.forEach((customPromo) => {
                      let chapterNumber = customPromo?.chapter.chapterNumber
                      let chapterSlug = customPromo?.chapter?.slug?.replace(/-/g, ' ')
                      gameID = gameID.replace(/-/g, ' ')

                      let formatedChapterName = `ch${chapterNumber} ${chapterSlug}`
                      if (gameID === formatedChapterName) {
                        promoValue = customPromo?.promo
                      }
                    })
                    let formatedPromo = {
                      platform: promo?.platform,
                      promo: promoValue,
                      label: promo?.label,
                      startDate: promo?.startDate,
                      endDate: promo?.endDate,
                      timezone: promo?.timezone,
                      active: currentTimeFrame,
                    }
                    if (currentTimeFrame) {
                      currentDiscount.push(formatedPromo)
                    }
                  }
                }
              })
            }
          }
        }
      }
    })
  })
  return currentDiscount
}
